import { Outlet } from "react-router-dom";

import { ThemeProvider } from "../../components/products/muggleTestV0/components/theme-provider";
import { Toaster } from "../../components/products/muggleTestV0/components/ui/toaster";
import "./globals.css";

export function MuggleTestLayout() {
  return (
    <ThemeProvider defaultTheme="system" enableSystem>
      <div className="min-h-screen bg-background text-foreground font-sans">
        <Outlet />
        <Toaster />
      </div>
    </ThemeProvider>
  );
}
